import React from "react"
import { Link } from "react-router-dom";

import { routes } from "../../constants/routes";


const containerStyles = {
    //height: '600px'
    height: "100vh"
};

const cardStyles = {
    minWidth: "40vw"
};

/**
 * Komponent reprezetujacy strone, do ktorej nie mamy dostepu
 * 
 * Na ten moment jest wykorzystywana do zalogowanego uzytkownika z rola, którą nie wspieramy
 */
const ForbiddenPage = () => {
    return (
        <div className="w3-display-container" style={containerStyles}>
            <div className="w3-card-4 w3-display-middle" style={cardStyles}>
                <div className="w3-container w3-theme">
                    <h1 className="w3-center">
                        403
                    </h1>
                </div>
                <div className="w3-padding">Odmowa dostępu</div>
                <div className="w3-padding"></div>
                <footer className="w3-container w3-theme-dark">
                    <div className="w3-bar">
                        {/*Powinnismy wylogowac uzytkownika, a nie tylko przekierowac na login*/}
                        <Link to={routes.LOGIN} className="w3-bar-item w3-right w3-small w3-btn">Wróc do głównej strony</Link>
                    </div>
                </footer>
            </div>

        </div>
    )
}

export default ForbiddenPage